(function () {
  function getItems(track) {
    return track ? Array.prototype.slice.call(track.querySelectorAll('[data-tl-owner-card]')) : [];
  }

  function currentIndex(viewport, items) {
    if (!items.length) return 0;
    var left = viewport.scrollLeft;
    var best = 0;
    var bestDist = Infinity;
    for (var i = 0; i < items.length; i += 1) {
      var dist = Math.abs(items[i].offsetLeft - left);
      if (dist < bestDist) {
        bestDist = dist;
        best = i;
      }
    }
    return best;
  }

  function scrollToIndex(viewport, items, index, behavior) {
    if (!items[index]) return;
    viewport.scrollTo({
      left: items[index].offsetLeft,
      behavior: behavior || 'smooth',
    });
  }

  function jumpToIndex(viewport, items, index) {
    if (!items[index]) return;
    var prevSnap = viewport.style.scrollSnapType;
    viewport.style.scrollSnapType = 'none';
    viewport.scrollLeft = items[index].offsetLeft;
    void viewport.offsetWidth;
    viewport.style.scrollSnapType = prevSnap;
  }

  function logicalIndex(rawIndex, realCount) {
    if (realCount <= 0) return 0;
    return ((rawIndex % realCount) + realCount) % realCount;
  }

  function syncDots(dotsWrap, index, pages) {
    if (!dotsWrap) return;
    var dots = dotsWrap.querySelectorAll('.tl-owner__dot');
    if (dots.length !== pages) {
      dotsWrap.innerHTML = '';
      for (var i = 0; i < pages; i += 1) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'tl-owner__dot' + (i === index ? ' is-active' : '');
        btn.setAttribute('data-tl-owner-dot', String(i));
        btn.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        if (i === index) btn.setAttribute('aria-current', 'true');
        dotsWrap.appendChild(btn);
      }
      return;
    }
    dots.forEach(function (dot, i) {
      var on = i === index;
      dot.classList.toggle('is-active', on);
      if (on) {
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.removeAttribute('aria-current');
      }
    });
  }

  function clearInfinite(track) {
    if (!track) return;
    track.querySelectorAll('[data-tl-owner-clone]').forEach(function (node) {
      node.remove();
    });
    delete track.dataset.tlOwnerInfinite;
    delete track.dataset.tlOwnerRealCount;
  }

  function setupInfinite(track) {
    if (!track) return 0;
    clearInfinite(track);

    var originals = Array.prototype.slice.call(
      track.querySelectorAll('[data-tl-owner-card]:not([data-tl-owner-clone])')
    );
    var realCount = originals.length;
    if (realCount < 2) {
      track.dataset.tlOwnerRealCount = String(realCount);
      return realCount;
    }

    originals.forEach(function (card, i) {
      card.dataset.tlOwnerIndex = String(i);
    });

    originals.forEach(function (card) {
      var clone = card.cloneNode(true);
      clone.dataset.tlOwnerClone = '1';
      track.appendChild(clone);
    });

    for (var i = originals.length - 1; i >= 0; i -= 1) {
      var clonePrev = originals[i].cloneNode(true);
      clonePrev.dataset.tlOwnerClone = '1';
      track.insertBefore(clonePrev, track.firstChild);
    }

    track.dataset.tlOwnerInfinite = '1';
    track.dataset.tlOwnerRealCount = String(realCount);
    return realCount;
  }

  function parseReviewData(card) {
    if (!card) return null;
    var node = card.querySelector('[data-tl-owner-review-json]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (err) {
      return null;
    }
  }

  function setAvatar(avatarEl, data) {
    if (!avatarEl) return;
    avatarEl.innerHTML = '';
    if (data && data.avatar) {
      var img = document.createElement('img');
      img.className = 'tl-owner__avatar-img';
      img.src = data.avatar;
      img.alt = (data && data.author) || '';
      img.loading = 'lazy';
      avatarEl.appendChild(img);
      return;
    }
    var fallback = document.createElement('span');
    fallback.className = 'tl-owner__avatar-fallback';
    fallback.setAttribute('aria-hidden', 'true');
    fallback.textContent = (data && data.initial) || '?';
    avatarEl.appendChild(fallback);
  }

  function setBadge(badgeEl, data) {
    if (!badgeEl) return;
    badgeEl.innerHTML = '';
    if (!data || !data.badge) {
      badgeEl.hidden = true;
      return;
    }
    var img = document.createElement('img');
    img.className = 'tl-owner__badge-img';
    img.src = data.badge;
    img.alt = '';
    img.loading = 'lazy';
    badgeEl.appendChild(img);
    badgeEl.hidden = false;
  }

  function initModal(section) {
    var modal = section.querySelector('[data-tl-owner-modal]');
    if (!modal || modal.dataset.tlOwnerModalReady === '1') return;
    modal.dataset.tlOwnerModalReady = '1';
    modal.dataset.tlOwnerModalSection = section.id || '';

    // Drop orphaned modals left on body after theme editor section reloads
    document.querySelectorAll('body > [data-tl-owner-modal]').forEach(function (node) {
      if (node === modal) return;
      if (node.dataset.tlOwnerModalSection === modal.dataset.tlOwnerModalSection) {
        node.remove();
      }
    });

    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    var imgEl = modal.querySelector('[data-tl-owner-modal-img]');
    var countEl = modal.querySelector('[data-tl-owner-modal-count]');
    var prevBtn = modal.querySelector('[data-tl-owner-modal-prev]');
    var nextBtn = modal.querySelector('[data-tl-owner-modal-next]');
    var quoteEl = modal.querySelector('[data-tl-owner-modal-quote]');
    var authorEl = modal.querySelector('[data-tl-owner-modal-author]');
    var roleEl = modal.querySelector('[data-tl-owner-modal-role]');
    var avatarEl = modal.querySelector('[data-tl-owner-modal-avatar]');
    var badgeEl = modal.querySelector('[data-tl-owner-modal-badge]');
    var dialog = modal.querySelector('[data-tl-owner-modal-dialog]');
    var closeTimer = null;

    var state = {
      images: [],
      index: 0,
      lastFocus: null,
      closing: false,
      renderToken: 0,
    };
    var preloadCache = Object.create(null);

    function isModalScrollTarget(target) {
      if (!dialog || !dialog.contains(target)) return false;
      var scrollBox = target.closest('.tl-owner__modal-quote, .tl-owner__modal-content');
      return !!(scrollBox && scrollBox.scrollHeight > scrollBox.clientHeight);
    }

    function lockPageScroll() {
      document.documentElement.classList.add('tl-owner-modal-open');
    }

    function unlockPageScroll() {
      document.documentElement.classList.remove('tl-owner-modal-open');
    }

    function onTouchMove(event) {
      if (!modal.classList.contains('is-open')) return;
      if (isModalScrollTarget(event.target)) return;
      event.preventDefault();
    }

    function onWheel(event) {
      if (!modal.classList.contains('is-open')) return;
      if (isModalScrollTarget(event.target)) return;
      event.preventDefault();
    }

    function onKeyScroll(event) {
      if (!modal.classList.contains('is-open')) return;
      var blockKeys = {
        ArrowUp: 1,
        ArrowDown: 1,
        PageUp: 1,
        PageDown: 1,
        Home: 1,
        End: 1,
        ' ': 1,
      };
      if (!blockKeys[event.key]) return;
      if (isModalScrollTarget(event.target)) return;
      event.preventDefault();
    }

    document.addEventListener('touchmove', onTouchMove, { passive: false });
    document.addEventListener('wheel', onWheel, { passive: false });
    document.addEventListener('keydown', onKeyScroll);

    function preloadUrl(url) {
      if (!url || preloadCache[url]) return preloadCache[url];
      var img = new Image();
      img.decoding = 'async';
      img.src = url;
      preloadCache[url] = img;
      return img;
    }

    function preloadAll(urls) {
      if (!urls || !urls.length) return;
      for (var i = 0; i < urls.length; i += 1) preloadUrl(urls[i]);
    }

    function preloadNeighbors(index, total) {
      if (total <= 1) return;
      preloadUrl(state.images[(index + 1) % total]);
      preloadUrl(state.images[(index - 1 + total) % total]);
    }

    function syncChrome(index, total) {
      if (countEl) {
        if (total > 1) {
          countEl.hidden = false;
          countEl.textContent = index + 1 + '/' + total;
        } else {
          countEl.hidden = true;
        }
      }
      if (prevBtn) prevBtn.hidden = total <= 1;
      if (nextBtn) nextBtn.hidden = total <= 1;
    }

    function applySrc(url) {
      if (!imgEl || !url) return;
      if (imgEl.getAttribute('src') === url) return;
      imgEl.src = url;
    }

    function isReady(img) {
      return !!(img && img.complete && img.naturalWidth);
    }

    function renderImage(opts) {
      opts = opts || {};
      if (!imgEl || !state.images.length) return;
      var total = state.images.length;
      var index = ((state.index % total) + total) % total;
      state.index = index;
      var url = state.images[index];
      var token = ++state.renderToken;

      imgEl.alt = (authorEl && authorEl.textContent) || '';
      syncChrome(index, total);
      preloadNeighbors(index, total);

      var cached = preloadUrl(url);
      if (isReady(cached)) {
        applySrc(url);
        return;
      }

      // Opening another review: seed from the card thumbnail so we never flash the previous review.
      if (opts.replaceStale) {
        var current = imgEl.getAttribute('src') || '';
        var currentIsThisReview = current && state.images.indexOf(current) !== -1;
        if (!currentIsThisReview) {
          if (opts.seedSrc) {
            applySrc(opts.seedSrc);
          } else {
            applySrc(url);
          }
        }
      }

      // Match Hear From Customers: keep current picture until next one is ready.
      cached.onload = function () {
        if (token !== state.renderToken) return;
        applySrc(url);
      };
      if (isReady(cached)) {
        applySrc(url);
      }
    }

    function open(data, startIndex, seedSrc) {
      if (!data || !data.images || !data.images.length) return;
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
      state.closing = false;
      state.images = data.images;
      state.index = Math.max(0, Math.min(data.images.length - 1, Number(startIndex) || 0));
      state.lastFocus = document.activeElement;

      if (quoteEl) quoteEl.textContent = data.quote || '';
      if (authorEl) authorEl.textContent = data.author || '';
      if (roleEl) {
        roleEl.textContent = data.role || '';
        roleEl.hidden = !data.role;
      }
      setAvatar(avatarEl, data);
      setBadge(badgeEl, data);

      // Warm cache so left/right feels instant (same as Hear From Customers).
      preloadAll(state.images);
      renderImage({ replaceStale: true, seedSrc: seedSrc || '' });
      lockPageScroll();
      modal.hidden = false;
      void modal.offsetWidth;
      modal.classList.add('is-open');
    }

    function finishClose() {
      modal.hidden = true;
      modal.classList.remove('is-open');
      state.closing = false;
      closeTimer = null;
      unlockPageScroll();
      if (state.lastFocus && typeof state.lastFocus.focus === 'function') {
        state.lastFocus.focus({ preventScroll: true });
      }
    }

    function close() {
      if (modal.hidden || state.closing) return;
      if (!modal.classList.contains('is-open')) {
        finishClose();
        return;
      }
      state.closing = true;
      modal.classList.remove('is-open');
      closeTimer = setTimeout(finishClose, 280);
    }

    function step(delta) {
      if (state.images.length <= 1) return;
      state.index += delta;
      renderImage();
    }

    function seedFromOpenBtn(openBtn) {
      var mediaImg = openBtn && openBtn.querySelector('img');
      if (!mediaImg) return '';
      return mediaImg.currentSrc || mediaImg.src || '';
    }

    section.addEventListener('click', function (event) {
      var openBtn = event.target.closest('[data-tl-owner-open]');
      if (!openBtn || !section.contains(openBtn)) return;
      var card = openBtn.closest('[data-tl-owner-card]');
      if (!card) return;
      event.preventDefault();
      open(parseReviewData(card), 0, seedFromOpenBtn(openBtn));
    });

    section.addEventListener('keydown', function (event) {
      var openBtn = event.target.closest('[data-tl-owner-open]');
      if (!openBtn || !section.contains(openBtn)) return;
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      var card = openBtn.closest('[data-tl-owner-card]');
      if (!card) return;
      open(parseReviewData(card), 0, seedFromOpenBtn(openBtn));
    });

    modal.addEventListener('click', function (event) {
      if (event.target.closest('[data-tl-owner-modal-close]')) {
        event.preventDefault();
        close();
        return;
      }
      if (dialog && !dialog.contains(event.target)) {
        close();
      }
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        step(-1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        step(1);
      });
    }

    var gallery = modal.querySelector('.tl-owner__modal-gallery');
    var touchStartX = 0;
    if (gallery) {
      gallery.addEventListener(
        'touchstart',
        function (event) {
          if (!event.changedTouches || !event.changedTouches.length) return;
          touchStartX = event.changedTouches[0].clientX;
        },
        { passive: true }
      );
      gallery.addEventListener(
        'touchend',
        function (event) {
          if (!event.changedTouches || !event.changedTouches.length) return;
          var dx = event.changedTouches[0].clientX - touchStartX;
          if (Math.abs(dx) < 40) return;
          step(dx < 0 ? 1 : -1);
        },
        { passive: true }
      );
    }

    document.addEventListener('keydown', function (event) {
      if (modal.hidden || !modal.classList.contains('is-open')) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        close();
        return;
      }
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        step(-1);
        return;
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        step(1);
      }
    });
  }

  function initSection(section) {
    if (!section || section.dataset.tlOwnerReady === '1') return;
    section.dataset.tlOwnerReady = '1';

    var viewport = section.querySelector('[data-tl-owner-viewport]');
    var track = section.querySelector('[data-tl-owner-track]');
    var dotsWrap = section.querySelector('[data-tl-owner-dots]');

    initModal(section);

    if (!viewport || !track) return;

    var scrollTimer = null;
    var normalizeTimer = null;
    var isJumping = false;
    var realCount = setupInfinite(track);

    function refreshChrome() {
      var items = getItems(track);
      var pages = realCount;
      var raw = currentIndex(viewport, items);
      var index = logicalIndex(raw, realCount);

      if (dotsWrap) {
        if (pages <= 1) {
          dotsWrap.hidden = true;
        } else {
          dotsWrap.hidden = false;
          syncDots(dotsWrap, index, pages);
        }
      }
    }

    function normalizeLoop() {
      if (isJumping || realCount < 2) return;
      var items = getItems(track);
      if (!items.length) return;
      var raw = currentIndex(viewport, items);

      if (raw < realCount) {
        isJumping = true;
        jumpToIndex(viewport, items, raw + realCount);
        isJumping = false;
        refreshChrome();
        return;
      }

      if (raw >= realCount * 2) {
        isJumping = true;
        jumpToIndex(viewport, items, raw - realCount);
        isJumping = false;
        refreshChrome();
      }
    }

    function onScroll() {
      if (isJumping) return;
      clearTimeout(scrollTimer);
      clearTimeout(normalizeTimer);
      scrollTimer = setTimeout(refreshChrome, 40);
      normalizeTimer = setTimeout(normalizeLoop, 360);
    }

    if ('onscrollend' in window) {
      viewport.addEventListener('scrollend', function () {
        if (isJumping) return;
        clearTimeout(normalizeTimer);
        normalizeLoop();
        refreshChrome();
      });
    }

    if (dotsWrap) {
      dotsWrap.addEventListener('click', function (event) {
        var dot = event.target.closest('[data-tl-owner-dot]');
        if (!dot || !dotsWrap.contains(dot)) return;
        var target = Number(dot.getAttribute('data-tl-owner-dot'));
        if (!Number.isFinite(target) || realCount < 1) return;
        target = Math.max(0, Math.min(realCount - 1, target));
        var items = getItems(track);
        // Always scroll the chosen review into the first (start) slot of the middle set.
        var next = realCount < 2 ? target : target + realCount;
        scrollToIndex(viewport, items, next, 'smooth');
      });
    }

    viewport.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      var logical = logicalIndex(currentIndex(viewport, getItems(track)), realCount);
      realCount = setupInfinite(track);
      var items = getItems(track);
      if (realCount >= 2 && items[logical + realCount]) {
        isJumping = true;
        jumpToIndex(viewport, items, logical + realCount);
        isJumping = false;
      }
      refreshChrome();
    });

    if (realCount >= 2) {
      var startItems = getItems(track);
      isJumping = true;
      jumpToIndex(viewport, startItems, realCount);
      isJumping = false;
    }
    refreshChrome();
  }

  function initAll() {
    document.querySelectorAll('[data-tl-owner]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section =
      event.target && event.target.querySelector
        ? event.target.querySelector('[data-tl-owner]')
        : null;
    if (!section && event.target.matches && event.target.matches('[data-tl-owner]')) {
      section = event.target;
    }
    if (section) {
      section.dataset.tlOwnerReady = '0';
      var modal = section.querySelector('[data-tl-owner-modal]');
      if (modal) modal.dataset.tlOwnerModalReady = '0';
      var reloadTrack = section.querySelector('[data-tl-owner-track]');
      if (reloadTrack) clearInfinite(reloadTrack);
      initSection(section);
    }
  });
})();
